/* ============================================================
   Hotel Products Direct — Custom Theme JavaScript
   ============================================================ */

(function () {
  "use strict";

  const PREFIX = "hpd";

  /* --- Mobile Navigation --- */
  function initMobileNav() {
    const hamburger = document.querySelector(`.${PREFIX}-hamburger`);
    const mobileNav = document.querySelector(`.${PREFIX}-mobile-nav`);
    const closeBtn = document.querySelector(`.${PREFIX}-mobile-nav-close`);

    if (!hamburger || !mobileNav) return;

    hamburger.addEventListener("click", () => {
      hamburger.classList.toggle("active");
      mobileNav.classList.toggle("active");
      document.body.style.overflow = mobileNav.classList.contains("active")
        ? "hidden"
        : "";
    });

    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        hamburger.classList.remove("active");
        mobileNav.classList.remove("active");
        document.body.style.overflow = "";
      });
    }

    // Close on escape
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && mobileNav.classList.contains("active")) {
        hamburger.classList.remove("active");
        mobileNav.classList.remove("active");
        document.body.style.overflow = "";
        hamburger.focus();
      }
    });
  }

  /* --- Cart API --- */
  async function addToCart(variantId, quantity) {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: quantity }],
        }),
      });
      const data = await response.json();
      updateCartCount();
      const cartItem = data.items ? data.items[0] : data;
      showStickyCart(cartItem);
      showCartToast(cartItem, quantity);
      return data;
    } catch (error) {
      console.error("Add to cart failed:", error);
    }
  }

  async function updateCartCount() {
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();
      const badges = document.querySelectorAll(`.${PREFIX}-cart-count`);
      badges.forEach((badge) => {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? "flex" : "none";
      });
    } catch (error) {
      console.error("Cart count update failed:", error);
    }
  }

  function showStickyCart(item) {
    const stickyCart = document.querySelector(`.${PREFIX}-sticky-cart`);
    if (!stickyCart) return;

    const titleEl = stickyCart.querySelector(`.${PREFIX}-sticky-cart-title`);
    const imageEl = stickyCart.querySelector(
      `.${PREFIX}-sticky-cart-image img`,
    );

    if (titleEl && item.title) titleEl.textContent = item.title;
    if (imageEl && item.image) imageEl.src = item.image;

    stickyCart.classList.add("active");

    // Auto-hide after 5 seconds
    clearTimeout(window._stickyCartTimeout);
    window._stickyCartTimeout = setTimeout(() => {
      stickyCart.classList.remove("active");
    }, 5000);
  }

  function showCartToast(item, quantity) {
    let toast = document.querySelector(`.${PREFIX}-cart-toast`);
    if (!toast) {
      toast = document.createElement("div");
      toast.className = `${PREFIX}-cart-toast`;
      toast.innerHTML = `
        <div class="${PREFIX}-cart-toast-progress">
          <div class="${PREFIX}-cart-toast-progress-bar"></div>
        </div>
        <div class="${PREFIX}-cart-toast-header">
          <span class="${PREFIX}-cart-toast-status">
            <span class="${PREFIX}-cart-toast-check">
              <svg viewBox="0 0 12 12"><polyline points="2 6 5 9 10 3"/></svg>
            </span>
            Added to cart
          </span>
          <button class="${PREFIX}-cart-toast-close" aria-label="Close">&times;</button>
        </div>
        <div class="${PREFIX}-cart-toast-body">
          <div class="${PREFIX}-cart-toast-image"><img src="" alt=""></div>
          <div class="${PREFIX}-cart-toast-info">
            <div class="${PREFIX}-cart-toast-title"></div>
            <div class="${PREFIX}-cart-toast-qty"></div>
          </div>
        </div>
        <div class="${PREFIX}-cart-toast-footer">
          <a href="/cart" class="${PREFIX}-cart-toast-view">View Cart</a>
        </div>
      `;
      document.body.appendChild(toast);

      toast
        .querySelector(`.${PREFIX}-cart-toast-close`)
        .addEventListener("click", () => dismissCartToast());
    }

    const titleEl = toast.querySelector(`.${PREFIX}-cart-toast-title`);
    const imageEl = toast.querySelector(`.${PREFIX}-cart-toast-image img`);
    const qtyEl = toast.querySelector(`.${PREFIX}-cart-toast-qty`);
    const progressBar = toast.querySelector(`.${PREFIX}-cart-toast-progress-bar`);

    if (titleEl && item.title) titleEl.textContent = item.title;
    if (imageEl && item.image) {
      imageEl.src = item.image;
      imageEl.alt = item.title || "";
    }
    if (qtyEl) qtyEl.textContent = `Qty: ${quantity || item.quantity || 1}`;

    // Reset progress bar animation
    progressBar.style.animation = "none";
    progressBar.offsetHeight; // force reflow
    progressBar.style.animation = "";

    // Show toast
    toast.classList.remove("dismissing");
    requestAnimationFrame(() => toast.classList.add("active"));

    // Auto-dismiss after 4.5s
    clearTimeout(window._cartToastTimeout);
    window._cartToastTimeout = setTimeout(() => dismissCartToast(), 4500);
  }

  function dismissCartToast() {
    const toast = document.querySelector(`.${PREFIX}-cart-toast`);
    if (!toast) return;
    clearTimeout(window._cartToastTimeout);
    toast.classList.add("dismissing");
    toast.classList.remove("active");
  }

  function initStickyCart() {
    const stickyCart = document.querySelector(`.${PREFIX}-sticky-cart`);
    if (!stickyCart) return;

    const closeBtn = stickyCart.querySelector(`.${PREFIX}-sticky-cart-close`);
    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        stickyCart.classList.remove("active");
      });
    }
  }

  /* --- Variant Selector --- */
  function initVariantSelectors() {
    document.querySelectorAll(`.${PREFIX}-variant-option`).forEach((option) => {
      option.addEventListener("click", function () {
        const group = this.closest(`.${PREFIX}-variant-group`);
        if (!group) return;

        group
          .querySelectorAll(`.${PREFIX}-variant-option`)
          .forEach((o) => o.classList.remove("selected"));
        this.classList.add("selected");

        updateSelectedVariant();
      });
    });
  }

  function updateSelectedVariant() {
    const form = document.querySelector(`.${PREFIX}-product-form`);
    if (!form) return;

    // Search from the product info wrapper so we can find the price above the form
    const productSection =
      form.closest(`.${PREFIX}-product-info`) ||
      form.closest(`.${PREFIX}-product-detail`) ||
      form.parentElement;

    const selectedOptions = [];
    form.querySelectorAll(`.${PREFIX}-variant-group`).forEach((group) => {
      const selected = group.querySelector(
        `.${PREFIX}-variant-option.selected`,
      );
      if (selected) selectedOptions.push(selected.dataset.value);
    });

    // Find matching variant
    const variantsScript = form.querySelector(".hpd-variants-json");
    const variantsData = variantsScript ? variantsScript.textContent : null;
    if (!variantsData) return;

    try {
      const variants = JSON.parse(variantsData);
      const match = variants.find((v) => {
        return v.options.every((opt, i) => opt === selectedOptions[i]);
      });

      if (match) {
        // Update price (search from product section, not form, since price is above form)
        const priceEl = productSection.querySelector(
          `.${PREFIX}-product-price`,
        );
        if (priceEl) {
          const formattedPrice = "$" + (match.price / 100).toFixed(2);
          const exGst = `<div class="${PREFIX}-price-ex-gst">ex GST</div>`;
          priceEl.innerHTML = match.compare_at_price
            ? `<span class="${PREFIX}-product-price-sale">${formattedPrice}</span>
                           <span class="${PREFIX}-card-price-compare">$${(match.compare_at_price / 100).toFixed(2)}</span>${exGst}`
            : formattedPrice + exGst;
        }

        // Update variant ID in hidden input
        const variantInput = form.querySelector('input[name="id"]');
        if (variantInput) variantInput.value = match.id;

        // Update SKU
        const skuEl = productSection.querySelector(`.${PREFIX}-product-sku`);
        if (skuEl) {
          skuEl.textContent = match.sku ? "SKU: " + match.sku : "";
          skuEl.style.display = match.sku ? "" : "none";
        }

        // Update URL
        history.replaceState(null, "", `?variant=${match.id}`);

        // Update main product image if variant has its own image
        if (match.featured_image) {
          if (window.hpdMainSwiper) {
            const slides = Array.from(window.hpdMainSwiper.slides);
            // Clean the variant image URL for comparison
            const variantImgBase = match.featured_image.src
              .split("?")[0]
              .replace(/_[0-9]+x[0-9]+(\.[a-z]+)$/i, "$1");
            const index = slides.findIndex((slide) => {
              const img = slide.querySelector("img");
              if (!img) return false;
              const slideImgBase = img.src
                .split("?")[0]
                .replace(/_[0-9]+x[0-9]+(\.[a-z]+)$/i, "$1");
              return slideImgBase === variantImgBase;
            });
            if (index !== -1) {
              window.hpdMainSwiper.slideTo(index);
            } else {
              // If variant image is missing from slider, update the current slide's image as fallback
              const activeImg =
                slides[window.hpdMainSwiper.activeIndex].querySelector("img");
              if (activeImg) {
                activeImg.src = match.featured_image.src;
                activeImg.alt = match.featured_image.alt || match.title;
              }
            }
          } else {
            // Fallback for non-swiper layout
            const mainImg = productSection
              .closest(`.${PREFIX}-product-detail`)
              ?.querySelector(`.${PREFIX}-product-main-image img`);
            if (mainImg) {
              mainImg.src = match.featured_image.src;
              mainImg.alt = match.featured_image.alt || match.title;
            }
          }
        }

        // Update add to cart button
        const addBtn = form.querySelector(`.${PREFIX}-add-to-cart`);
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? "Add to Cart" : "Sold Out";
        }

        // Update tier pricing display
        updateTierPricingDisplay(form, match);

        // Update reward points display
        updateRewardPointsDisplay(form, match);
      }
    } catch (e) {
      console.error("Variant update error:", e);
    }
  }

  /* --- Quantity Selector --- */
  function initQuantitySelectors() {
    document.querySelectorAll(`.${PREFIX}-quantity`).forEach((wrapper) => {
      const minus = wrapper.querySelector('[data-action="minus"]');
      const plus = wrapper.querySelector('[data-action="plus"]');
      const input = wrapper.querySelector("input");
      const minQty = parseInt(wrapper.dataset.minQty) || 1;

      if (!minus || !plus || !input) return;

      minus.addEventListener("click", () => {
        const val = parseInt(input.value) || minQty;
        if (val > minQty) input.value = val - 1;
      });

      plus.addEventListener("click", () => {
        const val = parseInt(input.value) || minQty;
        input.value = val + 1;
      });

      input.addEventListener("change", () => {
        const val = parseInt(input.value);
        if (!val || val < minQty) input.value = minQty;
      });
    });
  }

  /* --- Accordion --- */
  function initAccordions() {
    document
      .querySelectorAll(`.${PREFIX}-accordion-trigger`)
      .forEach((trigger) => {
        trigger.addEventListener("click", function () {
          const item = this.closest(`.${PREFIX}-accordion-item`);
          if (!item) return;

          const content = item.querySelector(`.${PREFIX}-accordion-content`);
          const isActive = item.classList.contains("active");

          // Close others in same accordion
          const accordion = item.closest(`.${PREFIX}-accordion`);
          if (accordion) {
            accordion
              .querySelectorAll(`.${PREFIX}-accordion-item.active`)
              .forEach((active) => {
                if (active !== item) {
                  active.classList.remove("active");
                  const c = active.querySelector(
                    `.${PREFIX}-accordion-content`,
                  );
                  if (c) c.style.maxHeight = null;
                  active
                    .querySelector(`.${PREFIX}-accordion-trigger`)
                    ?.setAttribute("aria-expanded", "false");
                }
              });
          }

          item.classList.toggle("active");
          this.setAttribute("aria-expanded", !isActive);

          if (content) {
            content.style.maxHeight = isActive
              ? null
              : content.scrollHeight + "px";
          }
        });
      });
  }

  /* --- Footer Mobile Accordion --- */
  function initFooterAccordion() {
    if (window.innerWidth >= 769) return;

    document
      .querySelectorAll(`.${PREFIX}-footer-column-title`)
      .forEach((title) => {
        title.style.cursor = "pointer";
        title.addEventListener("click", function () {
          const column = this.parentElement;
          const links = column.querySelector(`.${PREFIX}-footer-links`);
          if (!links) return;

          const isOpen = links.style.display !== "none";
          links.style.display = isOpen ? "none" : "block";
        });
      });
  }

  /* --- Product Thumbnail Gallery (Swiper) --- */
  function initProductGallery() {
    const mainSliderEl = document.querySelector(
      `.${PREFIX}-product-main-slider`,
    );
    const thumbSliderEl = document.querySelector(
      `.${PREFIX}-product-thumbnail-slider`,
    );

    if (!mainSliderEl) return;

    let thumbSwiper = null;
    if (thumbSliderEl) {
      thumbSwiper = new Swiper(thumbSliderEl, {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
          768: {
            slidesPerView: 5,
          },
        },
      });
    }

    const mainSwiper = new Swiper(mainSliderEl, {
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: thumbSwiper,
      },
    });

    // Pause any playing media when navigating away from a slide
    mainSwiper.on("slideChange", function () {
      mainSliderEl.querySelectorAll("video").forEach((v) => v.pause());
      mainSliderEl.querySelectorAll("iframe").forEach((iframe) => {
        const src = iframe.src;
        iframe.src = "";
        iframe.src = src;
      });
    });

    // Store globally for variant switching
    window.hpdMainSwiper = mainSwiper;
  }

  /* --- Add to Cart Form --- */
  function initAddToCart() {
    document.querySelectorAll(`.${PREFIX}-product-form`).forEach((form) => {
      form.addEventListener("submit", async function (e) {
        e.preventDefault();

        const variantId = this.querySelector('input[name="id"]')?.value;
        const qtyWrapper = this.querySelector(`.${PREFIX}-quantity`);
        const minQty = parseInt(qtyWrapper?.dataset.minQty) || 1;
        const quantity =
          parseInt(qtyWrapper?.querySelector("input")?.value) || minQty;

        if (!variantId) return;

        if (quantity < minQty) {
          alert(`This product has a minimum quantity of ${minQty}`);
          return;
        }

        const btn = this.querySelector(`.${PREFIX}-add-to-cart`);
        if (btn) {
          btn.disabled = true;
          btn.textContent = "Adding...";
        }

        await addToCart(variantId, quantity);

        if (btn) {
          btn.disabled = false;
          btn.textContent = "Added!";
          setTimeout(() => {
            btn.textContent = "Add to Cart";
          }, 2000);
        }
      });
    });

    // Product card quick add buttons
    document.querySelectorAll(`.${PREFIX}-quick-add`).forEach((btn) => {
      btn.addEventListener("click", async function (e) {
        e.preventDefault();
        const variantId = this.dataset.variantId;
        if (!variantId) return;
        const minQty = parseInt(this.dataset.minQty) || 1;

        this.disabled = true;
        this.textContent = "Adding...";

        await addToCart(variantId, minQty);

        this.disabled = false;
        this.textContent = "Added!";
        setTimeout(() => {
          this.textContent = "Add to Cart";
        }, 2000);
      });
    });
  }

  /* --- YouTube Embed in Descriptions --- */
  function initDescriptionVideos() {
    document.querySelectorAll(`.${PREFIX}-full-description`).forEach((desc) => {
      // Regex: optional [embed], YouTube URL (watch?v= or youtu.be/), optional [/embed]
      const ytRegex =
        /(?:\[embed\])?\s*(?:<a[^>]*>)?\s*https?:\/\/(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]{11})(?:[^\s<\]]*)(?:<\/a>)?\s*(?:\[\/embed\])?/gi;

      desc.innerHTML = desc.innerHTML.replace(ytRegex, (_, id) => {
        return `<div class="${PREFIX}-desc-video-wrapper"><iframe src="https://www.youtube.com/embed/${id}?rel=0" allow="autoplay; encrypted-media" allowfullscreen loading="lazy"></iframe></div>`;
      });
    });
  }

  /* --- Reward Points Display --- */
  function updateRewardPointsDisplay(form, variant) {
    const section = form.closest(`.${PREFIX}-section`);
    const container = section ? section.querySelector(`.${PREFIX}-reward-points`) : null;
    if (!container) return;

    const points = Math.floor(variant.price / 100);
    if (points > 0) {
      container.querySelector(`.${PREFIX}-reward-points-value`).textContent = points;
      container.style.display = "";
    } else {
      container.style.display = "none";
    }
  }

  /* --- Tier Pricing Display --- */
  function updateTierPricingDisplay(form, variant) {
    const container = form.querySelector(`.${PREFIX}-tier-pricing`);
    if (!container) return;

    const tierScript = form.querySelector(".hpd-tier-pricing-json");
    if (!tierScript) return;

    try {
      const tierMap = JSON.parse(tierScript.textContent);
      const data = tierMap[variant.id];

      if (!data || !data.tiers) {
        container.style.display = "none";
        container.innerHTML = "";
        return;
      }

      const tiers = typeof data.tiers === "string" ? JSON.parse(data.tiers) : data.tiers;
      const tiersArray = Array.isArray(tiers) ? tiers : [tiers];
      const variantPrice = data.price; // price in cents

      const html = tiersArray
        .map((tier) => {
          const tierPriceCents = parseFloat(tier.tier_price) * 100;
          const savePct = Math.round(
            ((variantPrice - tierPriceCents) / variantPrice) * 100,
          );
          const isFree = tierPriceCents === 0;
          if (isFree) {
            return `<div class="${PREFIX}-tier-row ${PREFIX}-tier-row--free">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path d="M20 12v10H4V12M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"/>
              </svg>
              Order 1 FREE sample to try
              <span class="${PREFIX}-tier-badge--free">FREE</span>
            </div>`;
          }
          const saveTag = savePct > 0 ? ` <span class="${PREFIX}-tier-save">Save ${savePct}%</span>` : "";
          return `<div class="${PREFIX}-tier-row">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/>
              <line x1="7" y1="7" x2="7.01" y2="7"/>
            </svg>
            ${tier.min_qty}+ pieces at <strong>$${tier.tier_price}</strong> each${saveTag}
          </div>`;
        })
        .join("");

      container.innerHTML = html;
      container.style.display = "";
    } catch (e) {
      console.error("Tier pricing update error:", e);
    }
  }

  /* --- Refresh cart section without full page reload --- */
  async function refreshCartSection() {
    var sectionEl = document.getElementById("hpd-insurance-checkbox");
    if (sectionEl) sectionEl = sectionEl.closest('[id^="shopify-section"]');
    if (!sectionEl) { window.location.reload(); return; }

    // Persist delivery note before replacing HTML
    var noteEl = document.getElementById("hpd-cart-note");
    var noteVal = noteEl ? noteEl.value : "";
    if (noteVal) {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ note: noteVal }),
      });
    }

    var sectionId = sectionEl.id.replace("shopify-section-", "");
    try {
      var res = await fetch("/cart?sections=" + sectionId);
      var json = await res.json();
      var html = json[sectionId];
      if (!html) { window.location.reload(); return; }

      var doc = new DOMParser().parseFromString(html, "text/html");
      sectionEl.innerHTML = doc.body.firstElementChild.innerHTML;

      // Re-execute inline scripts so window.hpdInsurance updates
      sectionEl.querySelectorAll("script").forEach(function (old) {
        var s = document.createElement("script");
        s.textContent = old.textContent;
        old.replaceWith(s);
      });

      updateCartCount();
      initShippingInsurance();
    } catch (e) {
      window.location.reload();
    }
  }

  /* --- Shipping Insurance (API-backed, qty=1) --- */
  function initShippingInsurance() {
    var config = window.hpdInsurance;
    if (!config || !config.apiUrl) return;

    var apiBase = config.apiUrl.replace(/\/+$/, "");
    var checkbox = document.getElementById("hpd-insurance-checkbox");
    if (!checkbox) return;

    checkbox.addEventListener("change", async function () {
      checkbox.disabled = true;

      try {
        if (this.checked) {
          var res = await fetch(apiBase + "/api/insurance/calculate", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ cartTotal: config.baseSubtotal }),
          });

          if (!res.ok) throw new Error("API error");
          var data = await res.json();

          if (config.inCart && config.lineKey) {
            await fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: config.lineKey, quantity: 1 }),
            });
          } else {
            await fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                items: [{ id: data.variantId, quantity: 1 }],
              }),
            });
          }
        } else {
          if (config.lineKey) {
            await fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: config.lineKey, quantity: 0 }),
            });
          }
        }

        await refreshCartSection();
      } catch (e) {
        console.error("Insurance error:", e);
        checkbox.checked = !checkbox.checked;
        checkbox.disabled = false;
      }
    });
  }

  /* --- Initialize --- */
  function init() {
    initMobileNav();
    initStickyCart();
    initVariantSelectors();
    initQuantitySelectors();
    initAccordions();
    initFooterAccordion();
    initProductGallery();
    initAddToCart();
    updateCartCount();
    initDescriptionVideos();
    initShippingInsurance();
  }

  document.addEventListener("DOMContentLoaded", init);
})();
